"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightNav = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const CtaButton_1 = require("../cta/CtaButton");
const LocaleOptions_1 = require("../locale/LocaleOptions");
const Search_1 = require("../search/Search");
const Account_1 = require("../user/Account");
const Styled = styled_components_1.default.div `
	display: flex;
	justify-content: flex-end;
	height: 100%;
	overflow: hidden;
`;
const RightNav = (props) => {
    const { callToAction = {}, callToActionDropdown = {}, isLoggedIn, accountLoading, displayName, hideSignIn, hideCallToAction, hideSearch, hideLocale, accountLinks = {}, localeOptions = [], onSearch, locale, } = props;
    return (react_1.default.createElement(Styled, { id: "rightNav", key: "right-nav-full", className: "right-nav-full" },
        !hideSearch ? react_1.default.createElement(Search_1.Search, { onSearch: onSearch }) : "",
        !hideLocale ? (react_1.default.createElement(LocaleOptions_1.LocaleOptions, { locale: locale, localeOptions: localeOptions, rightAlign: hideCallToAction || hideSignIn })) : (""),
        !hideSignIn ? (react_1.default.createElement(Account_1.Account, { isLoggedIn: isLoggedIn, accountLoading: accountLoading, displayName: displayName, accountLinks: accountLinks, rightAlign: hideCallToAction })) : (""),
        !hideCallToAction ? react_1.default.createElement(CtaButton_1.CtaButton, Object.assign({}, callToAction, { callToActionDropdown: callToActionDropdown })) : ""));
};
exports.RightNav = RightNav;
//# sourceMappingURL=RightNav.js.map